// extracted by mini-css-extract-plugin
export default {"choice":"styles_choice__eGzfJ","heading":"styles_heading__IAIav"};